export const PLATFORMS = {
    MOBILE: 'mobile_web',
    WEB: 'web',
};
